import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import { Banner } from "@/api/content/content.types.ts";
import { ROUTES } from "@/config/routes.ts";
import { cn } from "@/utils/cn.ts";

type MovieBannerTopProps = Pick<Banner, "distributor" | "is_new" | "rating">;

const MovieBannerTop = ({ distributor, is_new, rating }: MovieBannerTopProps): JSX.Element => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <div
      className={cn(
        "mad-md:top-4 absolute left-[3.625rem] top-8 z-[1] flex flex-row items-center gap-4 text-xs/none font-bold uppercase leading-3 max-xl:left-5 max-xl:top-5 max-lg:left-4 max-lg:top-4 max-md:left-4 max-md:gap-2",
        {
          "max-lg:left-8": pathname == "/",
        },
      )}
    >
      {distributor ? (
        <Link
          to={ROUTES.MAIN.DISTRIBUTOR.replace(":id", distributor.id.toString())}
          title={distributor.name}
          className={cn("block rounded !bg-orange-1 bg-on-primary p-[0.625rem] max-md:px-2 max-md:py-1.5", {})}
        >
          <img src={distributor.icon_svg} alt={distributor.name} className={"h-3 w-auto"} />
        </Link>
      ) : null}
      {is_new ? (
        <Link
          to={ROUTES.MAIN.PREMIERE}
          title={t("premiere")}
          className={"block rounded bg-on-primary p-[0.625rem] text-primary max-md:px-2 max-md:py-1.5 "}
        >
          {t("premiere")}
        </Link>
      ) : null}
      <div className={"rounded bg-orange-1 p-[0.625rem] max-md:px-2 max-md:py-1.5"}>
        {rating === 10 ? 10 : rating?.toFixed(1)}
      </div>
    </div>
  );
};

export default MovieBannerTop;
